// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N20, N70, N800, R400 } from '@atlaskit/theme/colors';
var textFieldDisabledStyles = "\n  min-height: 36px;\n  border-style: solid;\n  border-color: ".concat("var(--ds-border-disabled, #DFE1E6)", ";\n  border-radius: 3px;\n  border-width: 2px;\n  background-color: ", "var(--ds-background-accent-gray-subtlest, ".concat(N20, ")"), ";\n  cursor: default;\n  color: ", "var(--ds-text-disabled, ".concat(N70, ")"), ";\n\n  > div {\n    padding: 8px 6px;\n    line-height: normal\n  }\n");
var choiceDisabledStyles = "\n  > div {\n    border-style: none;\n    border-color: ".concat("var(--ds-border-disabled, #DFE1E6)", ";\n    border-radius: 3px;\n    border-width: 2px;\n    background-color: none;\n    cursor: default;\n    pointer-events: none;\n  }\n");
var choiceInvalidStyles = "\n  > div {\n    border-style: none;\n    border-color: ".concat("var(--ds-border-danger, #FF5630;)", "\n    border-radius: 3px;\n    border-width: 2px;\n    cursor: default;\n  }\n");
var choiceViewStyles = "\n  span {\n    color: ".concat("var(--ds-text, ".concat(N800, ")"), ";\n  }\n");
export var invalidFieldContainerStyles = "\n  border-style: solid;\n  border-color: ".concat("var(--ds-border-danger, ".concat(R400, ")"), ";\n  border-radius: 3px;\n  border-width: 2px;\n  cursor: default;\n");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export var FieldDisabledWrapper = styled.div({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> div': {
    borderStyle: 'solid',
    borderColor: "var(--ds-border-disabled, #DFE1E6)",
    borderRadius: 3,
    borderWidth: 2,
    backgroundColor: "var(--ds-background-accent-gray-subtlest, ".concat(N20, ")"),
    cursor: 'default',
    pointerEvents: 'none',
    color: "var(--ds-text-disabled, ".concat(N70, ")")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '*': {
    color: "var(--ds-text, #172B4D !important)",
    cursor: 'default'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ChoiceFieldWrapper = styled('div')(
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (props) {
  return props.isDisabled && choiceDisabledStyles;
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (props) {
  return props.isInvalid && choiceInvalidStyles;
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (props) {
  return props.isView && choiceViewStyles;
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export var TextfieldDisabledWrapper = styled.div(textFieldDisabledStyles);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ShortTextFieldWrapper = styled('div')({
  maxWidth: '240px'
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (props) {
  return props.isDisabled && textFieldDisabledStyles;
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ChoicePlaceholder = styled.div({
  margin: "var(--ds-space-500, 40px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var LabelWrapper = styled.div({
  display: 'flex'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ErrorWrapper = styled.div({
  height: '16px',
  marginTop: "var(--ds-space-050, 4px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SelectErrorContainer = styled.div(
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (props) {
  return props.isInvalid && invalidFieldContainerStyles;
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ShortFieldWrapper = styled.div({
  maxWidth: '160px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ViewWrapper = styled.div({
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: "var(--ds-text, ".concat(N800, ")")
});